"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = init;
exports.getRequestToken = getRequestToken;
exports["default"] = void 0;

var Castle = _interopRequireWildcard(require("@castleio/castle-js"));

var _constants = require("./utils/constants");

/*
 * The wrapper module for castle-js
 *
 * */
function init() {
  Castle.configure(_constants.CASTLE_APP_ID);
}

function getRequestToken() {
  return Castle.createRequestToken();
}

var _default = {
  init: init,
  getRequestToken: getRequestToken
};
exports["default"] = _default;
//# sourceMappingURL=castle.js.map